import actions from '../../actionTypes';

export default nodeAddress => {
  return {
    type: actions.DELETE_SITE_GATEWAY_SUCCESS,
    nodeAddress
  };
};



// WEBPACK FOOTER //
// ./src/reducers/status/actions/removeSiteGatewaySuccess.js